module.exports = __webpack_public_path__ + "img/14.5a421b90.jpg";